import React, { useState, useEffect } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { imgPath } from "../../utils/imagePath";

function SidebarAddClass() {
  document.getElementById("left_sidebar").classList.toggle("sidebar_sec");
}

const Search = () => {

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const allMentorsData = params.get('is_available') ? params.get('is_available') : 'all'
  const mentorsData = params.get('direction') ? params.get('direction') : 'asc'
  const [keyword, setKeyword] = useState("");
  const [allMentors, setAllMentors] = useState("");
  const [mentors, setMentors] = useState("");

  const handleClickSearch = (e) => {
    e.preventDefault()
    params.set("keyword", keyword);

    if (params.get("page") > 1) {
      params.set("page", 1);
    }

    history({
      pathname: location?.pathname,
      search: "?" + params,
    });
  };

  const history = useNavigate();

  const handleClickFilter = (value) => {
    setMentors(value)
    const params = new URLSearchParams(location.search);
    params.set("sort", "first_name");
    params.set("direction", value);
    if (params.get("page") > 1) {
      params.set("page", 1);
    }
    history({
      pathname: location?.pathname,
      search: "?" + params,
    });
  };

  const handleClickFilterAvailable = (value) => {
    setAllMentors(value)
    const params = new URLSearchParams(location.search);
    params.set("is_available", value);
    if (params.get("page") > 1) {
      params.set("page", 1);
    }
    history({
      pathname: location?.pathname,
      search: "?" + params,
    });
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const keywordData = params.get('keyword') ? params.get('keyword') : ''
    setKeyword(keywordData)
  }, [])

  return (
    <div className="mentor_form mb-4">
      <button
        onClick={SidebarAddClass}
        className="d-block d-md-none sidebar_toggle_btn mb-3"
      >
        <button className="btn">
          <i className="fas fa-bars"></i> Filter
        </button>
      </button>
      <Row>
        <Col md={6}>
          <div className="search position-relative mb-2 mb-md-0">
            <Form>
              <Form.Control
                type="text"
                value={keyword}
                placeholder="Search by name, country, organization or designation"
                onChange={(event) => {
                  setKeyword(event.target.value);
                }}
              ></Form.Control>
              <Button type='submit' onClick={(e) => handleClickSearch(e)}>
                <img
                  src={imgPath + "search.png"}
                  alt="search"
                />
              </Button>
            </Form>
          </div>
        </Col>
        <Col md={3}>
          <Form.Control
            as="select"
            name="order"
            value={mentors || mentorsData}
            onChange={(e) => {
              handleClickFilter(e.target.value);
            }}
          >
            <option value="asc">Mentor (A-Z)</option>
            <option value="desc">Mentor (Z-A)</option>
          </Form.Control>
        </Col>
        <Col md={3}>
          <Form.Control
            as="select"
            name="availablity"
            value={allMentors || allMentorsData}
            onChange={(e) => {
              handleClickFilterAvailable(e.target.value);
            }}
          >
            <option value="all">All Mentors</option>
            <option value="yes">Available</option>
            <option value="no">Not Available</option>
          </Form.Control>
        </Col>
      </Row>
    </div>
  );
};

export default Search;